
(function () {
  function initTransparentHeader() {
    var header = document.querySelector('header[data-bj-header]');
    if (!header) return;

    var hero = document.querySelector('.bj-hero, .bj-hero-section');

    if (!hero) return;

    header.classList.add('bj-transparent-header');

    var update = function () {
      var threshold = Math.max(hero.offsetHeight - header.offsetHeight, 40);
      header.classList.toggle('is-scrolled', window.scrollY > threshold);
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTransparentHeader);
  } else {
    initTransparentHeader();
  }
})();
